import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './service/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  if (/\/create\/[^/?#]+/.test(state.url)) {
    return true;
  }

  if (state.url.includes('/create')) {
    return true;
  }
  //
  // if (
  //   state.url.includes('/create') &&
  //   (!!localStorage.getItem('utmSource') ||
  //     !!localStorage.getItem('affiliateId') ||
  //     !!route.queryParams['affiliate_id'] ||
  //     !!route.queryParams['promptId'] ||
  //     localStorage.getItem('referrer')?.toLowerCase().includes('reddit'))
  // ) {
  //   return true;
  // }

  if (!inject(AuthService).isAuthenticated()) {
    inject(Router).navigate(['register'], { queryParams: { from: state.url } });
    return false;
  }

  return true;
};
